import { z } from "zod";

import { constantsData } from "@/data";

export const dataSourceEntryFormSchema = z.object({
    date: z.date().refine(
        (date) => date !== null && date !== undefined,
        { message: constantsData.msgs.requiredField },
    ),
    description: z.string().optional(),
});
